import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPartWatching = (partCode) => apiActionCreator({
  'endpoint': `/parts/${partCode}/watching`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PART_WATCHING,
    ActionTypes.FETCHED_PART_WATCHING,
    [
      ActionTypes.FETCHED_PART_WATCHING_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchSalesByYearAndMonth = (partCode, year, month) => apiActionCreator({
  'endpoint': `/parts/${partCode}/sales?year=${year}&month=${month}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SALES_BY_YEAR_AND_MONTH,
    ActionTypes.FETCHED_SALES_BY_YEAR_AND_MONTH,
    [
      ActionTypes.FETCHED_SALES_BY_YEAR_AND_MONTH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchOnOrdersByYearAndMonth = (partCode, year, month) => apiActionCreator({
  'endpoint': `/parts/${partCode}/providerOrders?year=${year}&month=${month}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ON_ORDERS_BY_YEAR_AND_MONTH,
    ActionTypes.FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH,
    [
      ActionTypes.FETCHED_ON_ORDERS_BY_YEAR_AND_MONTH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchReceptionsOrdersByYearAndMonth = (partCode, year, month) => apiActionCreator({
  'endpoint': `/parts/${partCode}/receptions?year=${year}&month=${month}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_RECEPTIONS_ORDERS_BY_YEAR_AND_MONTH,
    ActionTypes.FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH,
    [
      ActionTypes.FETCHED_RECEPTION_ORDERS_BY_YEAR_AND_MONTH_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changePartWatchingListPage = (value) => ({
  'type': ActionTypes.CHANGE_PART_WATCHING_LIST_PAGE,
  'payload': value,
});

export const changePartWatchingListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PART_WATCHING_LIST_PAGE_SIZE,
  'payload': value,
});

export const clearPartWatching = () => ({
  'type': ActionTypes.CLEAR_PART_WATCHING,
});
